import {Injectable} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {TrunkNotice} from "@knust/api-interfaces";
import {Observable} from "rxjs";
import {PaginatedResponse} from "../interfaces/paginated-response";
import { TRUNK_NOTICE_URL } from '@knust/core';

@Injectable({
  providedIn: 'root'
})
export class TrunkNoticeService {
  constructor(private http: HttpClient) { }

  loadTrunkNotices(query?: string): Observable<PaginatedResponse<TrunkNotice>> {
    return this.http.get<PaginatedResponse<TrunkNotice>>(TRUNK_NOTICE_URL + (query ?? ''));
  }

  saveTrunkNotice(newTrunkNotice: TrunkNotice | Omit<TrunkNotice, 'id'>) {
    return this.http.post<TrunkNotice>(TRUNK_NOTICE_URL, newTrunkNotice);
  }

  deleteTrunkNotice(trunkNoticeId: number) {
    return this.http.delete<TrunkNotice>(TRUNK_NOTICE_URL + '/' + trunkNoticeId);
  }

  restoreTrunkNotice(trunkNotice: TrunkNotice): Observable<TrunkNotice> {
    return this.http.patch<TrunkNotice>(TRUNK_NOTICE_URL + '/' + trunkNotice.id, {});
  }
}
